import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Stack,
  Typography,
  Collapse,
  Link as MuiLink,
} from "@mui/material";
import { styled, alpha } from "@mui/material/styles";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import DogLeg from "src/assets/dog-leg.png";
import LogoSvg from "src/assets/logo.png";
import MetaMaskLogo from "src/assets/metamask.png";
import PanImg from "src/assets/pan.png";
import Iconify from "src/components/Iconify";
import { USE_BASE_URL } from "src/config";
import useSetup from "src/cryptoUtilities/useSetup";
import { describeWalletError } from "src/cryptoUtilities/wallet-error";
import { useMetaMask } from "src/store/metamask";
import Web3 from "web3";

// ----------------------------------------------------------------------

const MENU_ITEMS = [
  // { title: "BTAFKey", path: "/key" },
  { title: "NFTs", path: "https://opensea.io/BTAFTokenNFT", isNew: true, isExternal: true },
  {
    title: "About Us",
    path: "#",
    children: [
      { title: "Blogs", path: "https://btaftoken.io/blogs/", isExternal: true },
      { title: "Our Team", path: "https://btaftoken.io/our-team/", isExternal: true },
      { title: "BTAFPay", path: "/pay" },
    ],
  },
  { title: "Stake", path: "/stake", isNew: true },
  { title: "Buy", path: "/pay" },
  { title: "Whisper Drop", path: "/pay" },
];

const SOCIALS = [
  { name: "Twitter", icon: "ri:twitter-x-fill", path: "https://x.com/btaftoken" },
  { name: "Telegram", icon: "ic:baseline-telegram", path: "https://t.me/taftoken" },
  { name: "Medium", icon: "ri:medium-fill", path: "https://medium.com/@TAFtoken" },
  { name: "Youtube", icon: "ri:youtube-fill", path: "https://www.youtube.com/channel/UCQ_UZw1Av5cSsQ6BB9Wq63g" },
  { name: "Facebook", icon: "ri:facebook-fill", path: "https://www.facebook.com/btaftoken.io" },
  { name: "NFT", icon: "ph:shopping-cart-fill", path: "https://bitcointaf.com/btaf-token-nfts/" },
  { name: "Github", icon: "ri:github-fill", path: "https://github.com/BTafPremiere" },
  { name: "Instagram", icon: "ri:instagram-fill", path: "https://www.instagram.com/btaftoken" },
];

const ListItemStyle = styled(ListItemButton)(({ theme }) => ({
  ...theme.typography.subtitle1,
  height: 48,
  textTransform: "none",
  color: "#fff",
  paddingLeft: theme.spacing(3),
  "&:hover": {
    backgroundColor: alpha("#fff", 0.08),
    color: "#00fba2",
  },
}));

const NewBadge = styled(Box)(({ theme }) => ({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "",
  color: "#00fba2",
  border: "1px solid #00fba2",
  fontSize: "10px",
  fontWeight: "bold",
  padding: "2px 8px",
  borderRadius: "10px",
  marginLeft: theme.spacing(1),
  textTransform: "uppercase",
}));

const GlowingButtonStyle = styled(Button)(({ theme }) => ({
  backgroundColor: "#101722",
  color: "#fff",
  borderRadius: "20px",
  padding: "6px 16px",
  fontWeight: "bold",
  fontSize: "12px",
  textTransform: "none",
  border: "2px solid #00fba2",
  boxShadow: "0 0 10px #00fba2, inset 0 0 5px #00fba2",
  "&:hover": {
    backgroundColor: alpha("#101722", 0.8),
    boxShadow: "0 0 15px #00fba2, inset 0 0 10px #00fba2",
  },
}));

const ConnectButtonStyle = styled(Button)(({ theme }) => ({
  borderRadius: "3rem",
  textTransform: "capitalize",
  fontWeight: 600,
  backgroundColor: alpha("#00fba2", 0.1),
  color: "#00fba2",
  border: "1px solid #00fba2",
  "&:hover": {
    backgroundColor: alpha("#00fba2", 0.2),
  },
}));

// ----------------------------------------------------------------------

export default function TemporaryDrawer() {
  const [state, setState] = useState({ left: false });
  const [openAbout, setOpenAbout] = useState(false);
  const [openConnect, setOpenConnect] = useState(false);
  const [storeData] = useMetaMask();
  const setup = useSetup();

  const toggleDrawer = (anchor, open) => (event) => {
    if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) return;
    setState({ ...state, [anchor]: open });
  };

  const handleToggleAbout = (e) => {
    e.stopPropagation();
    setOpenAbout(!openAbout);
  };

  const handleClose = () => {
    setOpenConnect(false);
  };

  const onConnected = async () => {
    const data = await setup();
    if (data) setOpenConnect(false);
  };

  useEffect(() => {
    async function checkForMetaMask() {
      if (window.ethereum) {
        try {
          await window.ethereum.request({ method: "eth_requestAccounts" });
        } catch (error) {
          // Fires on mount alongside the identical request in layout/index.jsx,
          // so -32002 here means the two collided, not that the user refused.
          const { code, raw } = describeWalletError(error);
          console.warn(`[wallet-connect] drawer mount-time eth_requestAccounts failed (${code}): ${raw}`);
        }
      }
    }
    checkForMetaMask();
  }, []);

  const list = (anchor) => (
    <Box
      sx={{
        width: 300,
        backgroundColor: "#121212",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        color: "#fff",
      }}
      role="presentation"
    >
      {/* Drawer Header */}
      <Box sx={{ p: 2, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <img src={LogoSvg} width={30} style={{ objectFit: "contain" }} alt="logo" />
          <Typography variant="subtitle1" sx={{ ml: 1, fontWeight: 800 }}>
            BTAF token
          </Typography>
          <MuiLink href="https://btaftoken.io/faqs/" target="_blank" sx={{ ml: 1, display: "flex" }}>
            <img src={DogLeg} style={{ width: "24px" }} alt="faq" />
          </MuiLink>
        </Box>
        <IconButton onClick={toggleDrawer(anchor, false)} sx={{ color: "#fff" }}>
          <Iconify icon="eva:close-fill" />
        </IconButton>
      </Box>

      <Box sx={{ px: 2, mb: 2 }}>
        <GlowingButtonStyle fullWidth href="https://btaftoken.io/buy/" target="_blank">
          Buy $BTAF
        </GlowingButtonStyle>
      </Box>

      <Divider sx={{ borderColor: alpha("#fff", 0.08) }} />

      <Box sx={{ flexGrow: 1, overflowY: "auto" }}>
        <List sx={{ pt: 1 }}>
          {MENU_ITEMS.map((item) => {
            if (item.children) {
              return (
                <React.Fragment key={item.title}>
                  <ListItemStyle onClick={handleToggleAbout}>
                    <ListItemText primary={item.title} primaryTypographyProps={{ variant: "subtitle1", fontWeight: 700 }} />
                    <Iconify
                      icon={openAbout ? "eva:arrow-ios-downward-fill" : "eva:arrow-ios-forward-fill"}
                      sx={{ width: 16, height: 16, ml: 1, color: alpha("#fff", 0.48) }}
                    />
                  </ListItemStyle>
                  <Collapse in={openAbout} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding sx={{ bgcolor: alpha("#fff", 0.03) }}>
                      {item.children.map((subItem) => (
                        <ListItemStyle
                          key={subItem.title}
                          component={subItem.path.startsWith("/") ? Link : MuiLink}
                          to={subItem.path}
                          href={subItem.path}
                          target={subItem.isExternal ? "_blank" : undefined}
                          sx={{ pl: 5, height: 40 }}
                          onClick={toggleDrawer(anchor, false)}
                        >
                          <ListItemText primary={subItem.title} primaryTypographyProps={{ variant: "body2" }} />
                        </ListItemStyle>
                      ))}
                    </List>
                  </Collapse>
                </React.Fragment>
              );
            }
            return (
              <ListItemStyle
                key={item.title}
                component={item.isExternal ? MuiLink : Link}
                to={item.path}
                href={item.path}
                target={item.isExternal ? "_blank" : undefined}
                onClick={toggleDrawer(anchor, false)}
              >
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <ListItemText
                    primary={item.title}
                    primaryTypographyProps={{ variant: "subtitle1", fontWeight: 700 }}
                    sx={{ flex: "none" }}
                  />
                  {item.isNew && <NewBadge>New</NewBadge>}
                </Box>
              </ListItemStyle>
            );
          })}
        </List>

        <Box sx={{ p: 2, mt: 1 }}>
          <ConnectButtonStyle
            fullWidth
            onClick={(e) => {
              e.stopPropagation();
              setOpenConnect(true);
            }}
          >
            {storeData.signerAddress ? "Wallet Connected" : "Connect Wallet"}
          </ConnectButtonStyle>

          <Button
            component={MuiLink}
            href="https://pancakeswap.finance/swap?outputCurrency=0xcAE3d82D63e2b0094bc959752993D3D3743B5D08"
            target="_blank"
            fullWidth
            sx={{
              mt: 2,
              borderRadius: "2rem",
              bgcolor: "#d18c35",
              color: "#fff",
              "&:hover": { bgcolor: "#b67a2d" },
              fontSize: "12px",
              textTransform: "none",
            }}
            startIcon={<img src={PanImg} width={18} alt="pancake" />}
          >
            Buy on PancakeSwap
          </Button>
        </Box>
      </Box>

      {/* Social Footer */}
      <Box sx={{ p: 2, bgcolor: alpha("#fff", 0.02) }}>
        <Stack direction="row" spacing={1} justifyContent="center" flexWrap="wrap">
          {SOCIALS.map((social) => (
            <IconButton
              key={social.name}
              component={MuiLink}
              href={social.path}
              target="_blank"
              sx={{
                color: alpha("#fff", 0.6),
                "&:hover": { color: "#00fba2", bgcolor: alpha("#00fba2", 0.08) },
              }}
            >
              <Iconify icon={social.icon} width={24} height={24} />
            </IconButton>
          ))}
        </Stack>
      </Box>
    </Box>
  );

  return (
    <>
      <div>
        {["left"].map((anchor) => (
          <React.Fragment key={anchor}>
            {/* <Button onClick={toggleDrawer(anchor, true)}>{anchor}</Button> */}
            <div
              className="burger"
              id="burger"
              onClick={toggleDrawer(anchor, true)}
            >
              <span className="burger-line"></span>
              <span className="burger-line"></span>
              <span className="burger-line"></span>
            </div>
            <Drawer
              anchor={anchor}
              open={state[anchor]}
              onClose={toggleDrawer(anchor, false)}
            >
              {list(anchor)}
            </Drawer>
          </React.Fragment>
        ))}
      </div>
      <Dialog
        open={openConnect}
        onClose={handleClose}
        sx={{
          "& .MuiPaper-root": {
            backgroundColor: "#212429",
            borderRadius: "2rem",
          },
        }}
      >
        <DialogTitle id="responsive-dialog-title" sx={{ color: "#fff", mt: 5 }}>
          <Typography variant="h5" sx={{ fontWeight: 800 }}>
            Connect Wallet
          </Typography>
        </DialogTitle>

        {/* Connect Wallet  */}
        <DialogContent>
          <Button
            variant="outlined"
            onClick={onConnected}
            sx={{
              borderRadius: "3rem",
              textTransform: "capitalize",
              mt: 1,
              fontWeight: 600,
              color: "#fff",
            }}
            fullWidth
            size="large"
            startIcon={
              <img src={MetaMaskLogo} style={{ margin: "0px 20px 0px 0px" }} />
            }
          >
            Meta Mask
          </Button>
          <Typography
            variant="subtitle2"
            fontWeight={500}
            style={{ color: "#ccc" }}
            mt={2}
            mb={2}
          >
            You don't have any crypto wallet?
          </Typography>
          <MuiLink
            href="https://academy.binance.com/en/articles/connecting-metamask-to-binance-smart-chain"
            target="_blank"
            underline="none"
          >
            <Button
              variant="contained"
              sx={{
                borderRadius: "1rem",
                textTransform: "capitalize",
                mt: 1,
                fontWeight: 600,
              }}
              className="connect-btn"
              fullWidth
              size="large"
            >
              Learn how to connect
            </Button>
          </MuiLink>
        </DialogContent>
      </Dialog>
    </>
  );
}
